module.exports = __webpack_public_path__ + "static/media/1_en.f945267d.png";